import { ReactComponent as Dashboard } from 'src/assets/images/Dashboard.svg';
import { ReactComponent as Metrics } from 'src/assets/images/Metrics.svg';
import { ReactComponent as Circle } from 'src/assets/images/Circle.svg';
import { ReactComponent as Graphics } from 'src/assets/images/Graphics.svg';

import { ReactComponent as Kyc } from 'src/assets/images/KYC.svg';
import { ReactComponent as Deposit } from 'src/assets/images/Deposit.svg';
import { ReactComponent as Wallets } from 'src/assets/images/Wallets.svg';
import { ReactComponent as Users } from 'src/assets/images/Users.svg';
import { ReactComponent as Orders } from 'src/assets/images/Orders.svg';
import { ReactComponent as Transactions } from 'src/assets/images/Transactions.svg';
import { ReactComponent as BankAccounts } from 'src/assets/images/BankAccounts.svg';
import { ReactComponent as WaitingList } from 'src/assets/images/WaitingList.svg';
import { ReactComponent as PresaleOrders } from 'src/assets/images/PresaleOrders.svg';
import { ReactComponent as PresaleUsers } from 'src/assets/images/PresaleUsers.svg';
import { ReactComponent as PresaleTokens } from 'src/assets/images/PresaleTokens.svg';
import { ReactComponent as Settings } from 'src/assets/images/Settings.svg';

import { LuBanknote, LuBellRing, LuLifeBuoy, LuScrollText, LuShield, LuUsers } from 'react-icons/lu';
// import { LuNetwork } from 'react-icons/lu';

import { PERMISSIONS, SidebarManagementGroupConfig } from './permissions';

export const SIDEBAR_BUTTONS = [
  { text: 'Dashboard', url: 'dashboard', img: Dashboard, permission: PERMISSIONS.DASHBOARD_READ },
  { text: 'Deposits', url: 'deposit', img: Deposit, permission: PERMISSIONS.TRANSACTION_READ },
  // No Withdraw.svg in assets, so this one uses an icon-set glyph.
  { text: 'Withdrawals', url: 'withdraw', img: LuBanknote, permission: PERMISSIONS.TRANSACTION_READ },
  { text: 'Wallets', url: 'wallets', img: Wallets, permission: PERMISSIONS.TRANSACTION_READ },
  { text: 'Users', url: 'users', img: Users, permission: PERMISSIONS.USER_READ },
  { text: 'Orders', url: 'orders', img: Orders, permission: PERMISSIONS.DASHBOARD_READ },
  { text: 'Transactions', url: 'transactions', img: Transactions, permission: PERMISSIONS.TRANSACTION_READ },
  { text: 'Bank Accounts', url: 'bank-account', img: BankAccounts, permission: PERMISSIONS.BANK_ACCOUNT_READ },
  { text: 'KYC', url: 'kyc', img: Kyc, permission: PERMISSIONS.KYC_REVIEW },
  { text: 'Waiting List', url: 'waiting-list-users', img: WaitingList, permission: PERMISSIONS.ALL },
  { text: 'Pre-sale Orders', url: 'presale-orders', img: PresaleOrders, permission: PERMISSIONS.DASHBOARD_READ },
  { text: 'Pre-sale Users', url: 'presale-users', img: PresaleUsers, permission: PERMISSIONS.USER_READ },
  { text: 'Pre-sale Token', url: 'presale-token', img: PresaleTokens, permission: PERMISSIONS.SETTINGS_READ },
  // { text: 'Cron Jobs', url: 'cron-jobs', img: LuNetwork, permission: PERMISSIONS.SETTINGS_READ },
  { text: 'Referrals', url: 'referrals', img: LuUsers, permission: PERMISSIONS.USER_READ },
  { text: 'Support', url: 'support', img: LuLifeBuoy, permission: PERMISSIONS.TICKET_READ },
  { text: 'Logs', url: 'logs', img: LuScrollText, permission: PERMISSIONS.DASHBOARD_READ },
  { text: 'Notifications', url: 'notifications', img: LuBellRing, permission: PERMISSIONS.USER_READ },
  { text: 'Settings', url: 'settings', img: Settings, permission: PERMISSIONS.SETTINGS_READ },
];

export const SIDEBAR_MANAGEMENT_GROUP: SidebarManagementGroupConfig = {
  text: 'Management',
  permission: PERMISSIONS.ALL,
  img: LuShield,
  items: [
    { text: 'All Users', url: 'management/admins', permission: PERMISSIONS.ALL },
    // { text: 'Permissions', url: 'management/permissions', permission: PERMISSIONS.ALL },
    { text: 'Roles', url: 'management/roles', permission: PERMISSIONS.ALL },
  ],
};

export const MANAGEMENT_DEFAULT_SUBROUTE = 'management/admins';

export const RECENT_ACTIVITY_HEADERS = ['Activity ID', 'Amount', 'Date', 'Status'];

export const RECENT_ACTIVITY_DATA = [
  {
    activity: {
      id: 'DY04210S0XA5',
      hash: 'Hash: 2111853732263042',
    },
    date: 'May 23, 2022',
    amount: '$250.00',
    status: 'Completed',
  },
  {
    activity: {
      id: 'DY04210S0XA5',
      hash: 'Hash: 2111853732263042',
    },
    date: 'May 23, 2022',
    amount: '$250.00',
    status: 'Completed',
  },
  {
    activity: {
      id: 'DY04210S0XA5',
      hash: 'Hash: 2111853732263042',
    },
    date: 'May 23, 2022',
    amount: '$250.00',
    status: 'Completed',
  },
  {
    activity: {
      id: 'DY04210S0XA5',
      hash: 'Hash: 2111853732263042',
    },
    date: 'May 23, 2022',
    amount: '$250.00',
    status: 'Completed',
  },
  {
    activity: {
      id: 'DY04210S0XA5',
      hash: 'Hash: 2111853732263042',
    },
    date: 'May 23, 2022',
    amount: '$250.00',
    status: 'Completed',
  },
  {
    activity: {
      id: 'DY04210S0XA5',
      hash: 'Hash: 2111853732263042',
    },
    date: 'May 23, 2022',
    amount: '$250.00',
    status: 'Completed',
  },
];

export const PRICES = [
  { id: 1, name: 'BTC', subname: 'Bitcoin', price: '10$' },
  { id: 2, name: 'ETH', subname: 'Ethereum', price: '1230$' },
  { id: 3, name: 'USDT', subname: 'TetherUS', price: '44.1231$' },
  { id: 4, name: 'BNB', subname: 'BNB', price: '11230$' },
  { id: 5, name: 'XRP', subname: 'Ripple', price: '1230$' },
  { id: 6, name: 'ADA', subname: 'Cardano', price: '88420$' },
  { id: 7, name: 'BUSD', subname: 'BUSD', price: '110$' },
  { id: 8, name: 'MATIC', subname: 'Polygon', price: '11230$' },
  { id: 9, name: 'DOGE', subname: 'Degocoin', price: '510$' },
  { id: 10, name: 'SOL', subname: 'Solana', price: '1000$' },
];

export const WIDGETS = [
  { id: 1, title: 'User activity', subtitle: 'You have total 99 users.', type: 'users', img: Metrics },
  { id: 2, title: 'Orders', subtitle: 'You have total 389 orders.', type: 'orders', img: Circle },
  { id: 3, title: 'Transactions', subtitle: 'You have total 389 transactions.', type: 'transactions', img: Metrics },
  { id: 4, title: 'Bank accounts', subtitle: 'You have total 389 bank accounts.', type: 'bank-accounts', img: Circle },
  { id: 5, title: 'KYC', subtitle: 'You have total 389 KYC.', type: 'kyc', img: Graphics },
];

export const USERS_HEADERS = ['Name', 'Email', 'Status', 'KYC Status', 'Created On'];

export const KYC_HEADERS = [
  'Customer',
  'Provider',
  'Status',
  'Review',
  'Risk',
  'Decision',
  'Updated',
];

/** The four fields the admin KYC list can match on. */
export const KYC_SEARCH_FIELDS = ['Name', 'Email', 'Country Code', 'ID'] as const;

export const KYC_PROVIDER_OPTIONS = [
  { value: 'VERIFF', label: 'Veriff' },
  { value: 'MANUAL', label: 'Manual' },
];

export const WAITING_LIST_HEADERS = ['Full name', 'Email', 'Email Status', 'Country Code', 'City', 'Pin Code'];

export const REFERRALS_HEADERS = ['Referred user', 'Their code', 'Referred by', 'Referrer code'];

export const MANUAL_TRANSACTIONS_HEADERS = [
  'User',
  'Amount',
  'Status',
  'Decision',
  'Requested at',
];

export const SUPPORT_HEADERS = ['Subject', 'User', 'Email', 'Status', 'Created at'];

export const BANK_ACCOUNTS_HEADERS = ['Account number', 'Bank name', 'Swift BIC Code', 'Status', 'Created at'];

export const PRESALE_ORDERS_HEADERS = [
  'Order No',
  'Status',
  'Blockchain',
  'BXT Base Price',
  'Payment Coin',
  'Stage',
  'Tokens',
  'Amount USD',
];

export const PRESALE_USERS_HEADERS = [
  'Referral Reward',
  'Total Allocation',
  'Pending Allocation',
  'Email',
  'KYC Status',
  'Name',
  'Created At',
];

export const CRON_JOBS_HEADERS = ['Name', 'Description'];

export const TRANSACTIONS_HEADERS = ['Currency Code', 'Kind', 'Recipient Address', 'Status'];

export const ORDERS_HEADERS = ['User', 'Direction', 'Pair', 'Kind', 'Status', 'Created at'];

export const WALLETS_HEADERS = [
  'Address',
  'Owner',
  'Owner type',
  'CCY',
  'Blockchain',
  'Balance',
  'Created on',
];

export function formatBigNumber(value: number | string, options?: { decimals?: number }): string {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  const decimals = options?.decimals ?? 2;

  if (isNaN(num)) return '-';

  const absNum = Math.abs(num);

  let result = '';
  if (absNum >= 1_000_000_000) {
    result = (num / 1_000_000_000).toFixed(decimals) + 'B';
  } else if (absNum >= 1_000_000) {
    result = (num / 1_000_000).toFixed(decimals) + 'M';
  } else {
    result = num.toLocaleString('en-US', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }

  return result;
}

// ------------------------- Filter options -------------------------

// Values the API matches exactly, mirrored from the backend enums
// (src/constants/{user,kyc,order}.js). A field listed here is offered as a
// picker rather than a text box.

const toOption = (value: string) => ({
  value,
  label: value
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/(^|\s)\w/g, (c) => c.toUpperCase()),
});

export const USER_STATUS_OPTIONS = ['ACTIVE', 'INACTIVE', 'SUSPENDED', 'BANNED'].map(toOption);

export const KYC_STATUS_OPTIONS = [
  'PENDING',
  'VERIFIED',
  'CANCELED',
  'FAILED',
  'EXPIRED',
  'UNVERIFIED',
].map(toOption);

export const ORDER_DIRECTION_OPTIONS = ['BUY', 'SELL'].map(toOption);

export const ORDER_KIND_OPTIONS = ['MARKET', 'LIMIT', 'STOP_LIMIT'].map(toOption);

export const ORDER_STATUS_OPTIONS = [
  'PENDING',
  'ACTIVE',
  'FULFILLED',
  'FAILED',
  'CANCELLED',
].map(toOption);

// The list endpoint covers on-chain movement only, so it accepts just these two
// kinds — transfers and the manual cheque flow are deliberately excluded.
export const TRANSACTION_KIND_OPTIONS = ['DEPOSIT', 'WITHDRAW'].map(toOption);

export const TRANSACTION_STATUS_OPTIONS = [
  'AWAIT_APPROVAL',
  'BROADCASTED',
  'PENDING',
  'SUCCESS',
  'FAILED',
  'REJECTED',
  'MINED',
  'CREATED',
  'PREPARED',
  'SIGNED',
  'FROZEN',
  'RELEASED',
].map(toOption);
